import React, { useEffect, useState } from "react";
import { Col, Row, Input, Form } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import { useParams } from "react-router-dom";

function StudentDetails() {
  const [form] = Form.useForm();

  const { student_id } = useParams();
  const [responseData, getRequest] = useApi(
    `/admin/student/get-details/${student_id}`,
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data =
      responseData.data !== BLANK_VALUE && responseData.data !== null
        ? responseData.data
        : [];
    if (data.length > 0) {
      form.setFieldsValue(data[0]);
    }
  }, [responseData]);

  return (
    <Form layout="vertical" form={form} disabled={true}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="name" label="Student Name">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="father_name" label="Father's Name">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="mother_name" label="Monther's Name">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="gender" label="Gender">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="date_of_birth" label="Date of Birth">
            <Input />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item name="college" label="College">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="studying_in" label="Studing In">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="email" label="Email">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="mobile" label="Mobile">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="address" label="Address">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default StudentDetails;
